export default __webpack_public_path__ + "static/media/Image (10).2d22aada.png";